var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5H6.425L16.2 9.725L14.775 8.3L5 18.075V19.5ZM3 21.5V17.25L16.2 4.075C16.4 3.89167 16.6208 3.75 16.8625 3.65C17.1042 3.55 17.3583 3.5 17.625 3.5C17.8917 3.5 18.15 3.55 18.4 3.65C18.65 3.75 18.8667 3.9 19.05 4.1L20.425 5.5C20.625 5.68333 20.7708 5.9 20.8625 6.15C20.9542 6.4 21 6.65 21 6.9C21 7.16667 20.9542 7.42083 20.8625 7.6625C20.7708 7.90417 20.625 8.125 20.425 8.325L7.25 21.5H3ZM15.475 9.025L14.775 8.3L16.2 9.725L15.475 9.025Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Edit.6d3bf3f0.svg";
export { ForwardRef as ReactComponent };